import { formatLimitDate, limitEffectiveFromDate, limitEffectiveToDate } from 'shared/lib/card-limit-dates';
import { buildSkeletonLimitRows, defaultLimit } from 'shared/lib/card-limit-defaults';
export { formatLimitDate, limitEffectiveFromDate, limitEffectiveToDate, buildSkeletonLimitRows, defaultLimit };
const asOptions = (values) => values.map(v => ({ name: v, value: v }));
export const LIMIT_SCOPE_OPTIONS = asOptions([
    'TOTAL_SPEND',
    'ATM_WITHDRAWAL',
    'POS_PURCHASE',
    'ECOMMERCE',
    'INTERNATIONAL',
    'CONTACTLESS',
    'ALLOWANCE',
    'CARD_CONTROL_LIMIT',
]);
export const WINDOW_TYPE_OPTIONS = asOptions(['PER_TXN', 'DAILY', 'WEEKLY', 'MONTHLY', 'ROLLING_24H', 'CUSTOM']);
/** Limit create/edit dialog — subset of window types shown in the form. */
export const LIMIT_FORM_WINDOW_TYPE_OPTIONS = asOptions(['DAILY', 'WEEKLY', 'MONTHLY']);
export const STATUS_OPTIONS = asOptions(['ACTIVE', 'INACTIVE', 'EXPIRED']);
export const CHANNEL_OPTIONS = asOptions([
    'ATM',
    'POS',
    'ECOMMERCE',
    'MOBILE',
    'CONTACTLESS',
    'QR_CODE',
    'RECURRING',
    'ONE_TIME',
    'NFC',
    'CHIP',
    'MAGNETIC_STRIPE',
    'ALL',
]);
export const COUNTRY_OPTIONS = asOptions([
    'DOMESTIC',
    'INTERNATIONAL',
    'REGION_ASIA',
    'REGION_EUROPE',
    'REGION_AMERICAS',
    'REGION_AFRICA',
    'REGION_OCEANIA',
    'SPECIFIC_COUNTRY',
    'SANCTIONED_COUNTRIES',
    'HIGH_RISK_COUNTRIES',
    'ALL',
]);
const FORM_WINDOW_TYPES = new Set(LIMIT_FORM_WINDOW_TYPE_OPTIONS.map(o => o.value));
/** Maps API/list row → the same shape used by the create limit form. */
export function toLimitFormState(row, owner) {
    const defaults = owner
        ? defaultLimit(owner)
        : defaultLimit(row.cardId != null ? { cardId: row.cardId } : { productId: row.productId ?? 0 });
    return {
        id: row.id ?? null,
        productId: row.productId ?? defaults.productId ?? null,
        cardId: row.cardId ?? defaults.cardId ?? null,
        limitScope: 'TOTAL_SPEND',
        windowType: FORM_WINDOW_TYPES.has(row.windowType ?? '') ? row.windowType : defaults.windowType,
        amountLimit: null,
        countLimit: row.countLimit ?? defaults.countLimit ?? 0,
        currencyCode: row.currencyCode ?? defaults.currencyCode ?? '',
        isOverride: row.isOverride ?? defaults.isOverride ?? false,
        status: 'ACTIVE',
        appliesToChannel: CHANNEL_OPTIONS.some(o => o.value === row.appliesToChannel)
            ? row.appliesToChannel
            : defaults.appliesToChannel,
        appliesToCountry: COUNTRY_OPTIONS.some(o => o.value === row.appliesToCountry)
            ? row.appliesToCountry
            : defaults.appliesToCountry,
        effectiveFrom: row.effectiveFrom ?? null,
        effectiveUntil: row.effectiveUntil ?? null,
    };
}
/** Normalizes form values sent to the API (hidden fields use fixed values). */
export function toLimitApiPayload(form) {
    return {
        ...form,
        limitScope: 'TOTAL_SPEND',
        amountLimit: null,
        status: 'ACTIVE',
    };
}
